import { VStack } from '@chakra-ui/react';
import { memo } from 'react';
import ListenAudio from '../HelperComponents/ListenAudio';
import RightAnswer from '../HelperComponents/RightAnswer';
import useMediaOptions from './useMediaOptions';

const ListenWithType = memo(({ exercise, setSelectedAnswer, disabled, ...props }) => {
  const {
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  } = useMediaOptions({
    exercise,
    hasAudio: true
  });

  return (
    <VStack 
      textAlign="center" 
      spacing={[5, 5, 10]}
      width="100%"
      data-testid={props['data-testid']}
    >
      <ListenAudio 
        data={exercise}
        audioControl={{
          currentlyPlaying,
          onAudioPlay,
          stopAllAudio
        }}
      />
      <RightAnswer 
        exercise={exercise}
        setSelectedAnswer={setSelectedAnswer}
        disabled={disabled}
        {...props}
      />
    </VStack>
  );
});

export default ListenWithType;